import {FC} from "react";
import {ReportDebitCustomerSearchPanel, ReportPage} from "../../../components";
import {getPageNameByPageId, getSystemLanguageId, getUserId} from "../../../utils";
import {SearchReportDebitCustomerPage} from "../../../serviceBroker/customersReportApiServiceBroker";
import {DebitCustomerReportSearchParamsModel, PageEnum} from "../../../models";

export const ReportDebitCustomerPage: FC = () => {
    const initialState: DebitCustomerReportSearchParamsModel = {
        Lang: getSystemLanguageId(),
        userId: getUserId(),
    };
    return (
        <ReportPage
            InitialState={initialState}
            SearchApi={SearchReportDebitCustomerPage}
            searchHeader={getPageNameByPageId(PageEnum.ReportCustomerDebits)}
            SearchPanel={ReportDebitCustomerSearchPanel}
            formId={PageEnum.ReportCustomerDebits}
        />
    );
};
